import React from 'react';
import {Link} from 'react-admin';
import VisibilityIcon from '@material-ui/icons/Visibility';

const LinkMostrarButtonNotificacion = ({record}) => {
    return (
        <Link to={`${record.link_notificacion}`}>
            <div title={''}
                 style={{display: 'flex', flexWrap: 'nowrap', alignItems: 'center', color: '#0064c8', backgroundColor: '#ffffff'}}
            >
                <VisibilityIcon style={{fontSize: 20}}/> Mostrar
            </div>
        </Link>
    );
}

LinkMostrarButtonNotificacion.defaultProps = {
    source: '',
    addLabel: true,
};

export default LinkMostrarButtonNotificacion;